export default "__VITE_ASSET__7625776e__"